import {Component, OnInit} from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, ViewController} from 'ionic-angular';

import { PostPopoverComponent } from '../../../components/post-popover/post-popover';
import { PostPage } from '../post/post';
import { NewPostPage } from '../new-post/new-post';
import { SearchPage } from '../search/search';
import { ProfilePage } from '../profile/profile';


@Component({
  selector: 'feed-club',
  templateUrl: 'feed-club.html',
})
export class FeedClub implements OnInit{

  club;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController) {

  }

  ngOnInit() {
    this.club = this.navParams.get('club');
    console.log(this.club);
  }

  ionViewDidLoad() {

  }

  presentPopover(event) {
    event.stopPropagation();

    let popover = this.popoverCtrl.create(PostPopoverComponent, {}, {
      cssClass: 'my-popover'
    });
    popover.present({
      ev: event
    });
  }



  newPost() {
    let modal = this.modalCtrl.create(NewPostPage, {isClub: true, clubId: this.club.id});
    modal.present().then(() => {});
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer));
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/feed-club/feed-club.component.ts